<section class="app-cit-top">
  <!-- <img
    class="app-cit-top__img"
    alt="banner"
    [src]="bannerUrl()"
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.5"
  /> -->

  <video
    #video
    autoplay
    muted
    loop
    playsinline
    class="app-cit-top__img"
    *ngIf="bannerUrl()"
    id="CityVideo"
    [controls]="false"
    (canplay)="video.play()"
    (loadedmetadata)="video.muted = true"
  >
    <source src="{{ bannerUrl() }}" type="video/mp4" />
  </video>

  <div class="app-cit-top__txt" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'500'">
    <p class="app-cit-top__txt__pro">PRO:EXPERIENCE</p>
    <p class="app-cit-top__txt__cit">{{ cityName() }}</p>
    <p class="app-cit-top__txt__dat">{{ dates() }}</p>
  </div>

  <a (click)="onScrollToCity()" class="app-cit-top__arr">
    <img src="assets/images/pages/cities/arrow.svg" width="30" height="30" />
  </a>
</section>
